import { Term } from '../model/term';

export const TERMS: Term[] = [
    {Id: 0, Description: '', Show: '', Required: false},
    {Id: 1, Description: 'TechnicianTermsAndPrivacy', Show: 'checkbox', Required: true},
    {Id: 2, Description: 'TechnicianGeneralCondition', Show: 'checkbox', Required: true},
    {Id: 3, Description: 'NewsletterSubscription', Show: 'radio-group', Required: false},
    {Id: 4, Description: 'UserTermsAndPrivacy', Show: 'checkbox', Required: true},
    {Id: 5, Description: 'UserGeneralCondition', Show: 'checkbox', Required: true},
    {Id: 6, Description: 'UserStartService', Show: 'checkbox', Required: true},
    {Id: 7, Description: 'Privacy', Show: 'checkbox', Required: true},
    {Id: 8, Description: 'Terms', Show: 'checkbox', Required: true},
    {Id: 9, Description: 'TransferDataGroupCompanies', Show: 'radio-group', Required: false},
];

export const USER_TERMS = [5, 6, 3, 4];
export const USER_PROFILE_TERMS = [3];
export const TECHNICIAN_TERMS = [1, 2, 3];
